/**
 * `<PrizePool>` compound primitive — public surface.
 *
 * The hero card consolidates what used to be `<PrizePool.Total />` +
 * `<PrizePool.YourShare />` + `<PrizePool.PipelineMessage />` +
 * `<PrizePool.LoserMessage />` + `<PrizePool.BuybackBreakdown />` into one
 * stage-aware `<PrizePool.Card />` (see `prize-pool-card.tsx`). The provider
 * still owns shared modal state, so multiple `<HelpButton>` instances inside
 * one provider open the same modal.
 */

export { PrizePoolCard } from './prize-pool-card';
export {
  type PrizePoolActions,
  PrizePoolContext,
  type PrizePoolContextValue,
  type PrizePoolPayoutEstimateView,
  type PrizePoolStage,
  type PrizePoolState,
  usePrizePoolContext,
} from './prize-pool-context';
export { PrizePoolHelpButton } from './prize-pool-help-button';
export { PrizePoolHowItWorksModalSubcomponent } from './prize-pool-how-it-works-modal';
export { PrizePoolProvider, type PrizePoolProviderProps } from './prize-pool-provider';

import { PrizePoolCard } from './prize-pool-card';
import { PrizePoolHelpButton } from './prize-pool-help-button';
import { PrizePoolHowItWorksModalSubcomponent } from './prize-pool-how-it-works-modal';
import { PrizePoolProvider } from './prize-pool-provider';

/**
 * Compound surface — preferred consumer entry. Use as `<PrizePool.Provider>`,
 * `<PrizePool.Card marketPubkey={...} />`, etc.
 */
export const PrizePool = {
  Provider: PrizePoolProvider,
  Card: PrizePoolCard,
  HelpButton: PrizePoolHelpButton,
  HowItWorksModal: PrizePoolHowItWorksModalSubcomponent,
} as const;
